// key列表
import {error} from "@/utils/elMessage";
import {isBlank} from "@/utils/fun";

export const keys = {
    // 用户详情
    userInfo: 'USER_INFO',
    // token
    token: 'TOKEN',
    // 刷新token
    refreshToken: 'REFRESH_TOKEN',
    // web详情
    webInfo: 'WEB_INFO',
    // 第三方/外来API
    exoticAPI: 'EXOTIC_API'
}

/**
 * 设置本地存储
 * @param key 键
 * @param val 值
 * @param expireTime 过期时间（单位：秒）
 */
export const set = (key, val, expireTime = -1) => {
    try {
        if (isBlank(key) || isBlank(expireTime)) error('参数数据为空')
        const time = expireTime === -1 ? -1 : Date.now() + 1000 * expireTime
        localStorage.setItem(key, JSON.stringify({
            value: val,
            expireTime: time
        }))
    } catch (e) {
        error('本地存储错误：' + e)
    }
}

/**
 * 更新本地存储
 * @param key 键
 * @param val 值
 */
export const update = (key, val) => {
    try {
        if (isBlank(key)) error('参数数据为空')
        const json = localStorage.getItem(key)
        if (!isBlank(json)) {
            const {expireTime} = JSON.parse(json)
            localStorage.setItem(key, JSON.stringify({
                value: val,
                expireTime: expireTime
            }))
        }
    } catch (e) {
        error('本地存储更新数据错误：' + e)
    }
}

/**
 * 获取本地存储
 * @param key 键
 */
export const get = (key) => {
    try {
        if (isBlank(key)) error('参数key为空')
        const json = localStorage.getItem(key)
        if (isBlank(json)) return null
        const data = JSON.parse(json)
        const {expireTime} = data
        if (expireTime !== null && expireTime !== -1 && Date.now() > expireTime) {
            localStorage.removeItem(key)
            return null
        }
        return data.value
    } catch (e) {
        error('本地存储错误：' + e)
        return null
    }
}

/**
 * 删除本地存储
 * @param key 键
 */
export const remove = (key) => {
    try {
        if (isBlank(key)) error('参数key为空')
        localStorage.removeItem(key)
        return true
    } catch (e) {
        error('本地存储删除错误：' + e)
        return false
    }
}
